import PropTypes from 'prop-types';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import FormElementPresenter from './FormElementPresenter';

const Item = styled.div`
  display: flex;
  user-select: none;
  padding: 0.5rem;
  margin: 0 0 0.5rem 0;
  align-items: flex-start;
  align-content: flex-start;
  line-height: 1.5;
  border-radius: 3px;
  background: #fff;
  border: 1px ${(props) => (props.isDragging ? 'dashed #000' : 'solid #ddd')};
  height:auto;
`;

const FormElement = ({
    item,
    index,
    editFormElement,
    deleteFormElement,
}) => {
    const { id } = item;

    return (
        <Draggable
            key={`form-${id}`}
            draggableId={`form-${id}`}
            index={index}
        >
            {(provided, snapshot) => (
                <Item
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    isDragging={snapshot.isDragging}
                    style={provided.draggableProps.style}
                >
                    <FormElementPresenter
                        editCallback={editFormElement}
                        deleteCallback={deleteFormElement}
                        item={item}
                        dragHandleProps={provided.dragHandleProps}
                    />
                </Item>
            )}
        </Draggable>
    );
};

export default FormElement;

FormElement.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
};
